import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRemoveKeyframe: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconRemoveKeyframe"><Path d="M12 2L2 12L12 22L22 12L12 2Z" stroke="currentColor"/><Path d="M9 12H15" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconRemoveKeyframe;
